import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { SubtitlePluginPathType } from '@module/apis/client-side/subtitle/type';

export const subtitleQueryKeys = createQueryKeys('subtitle', {
  getSubtitleRequestList: () => ['getSubtitleRequestList'],
  getSubtitleRequestInfo: () => ['getSubtitleRequestInfo'],
  getSubtitleApplyCheck: () => ['getSubtitleApplyCheck'],
  getSubtitlePluginPath: (type: SubtitlePluginPathType) => [type],
  postSubtitleRequestHangul: () => ['postSubtitleRequestHangul'],
  getSubtitleStreamKey: () => ['getSubtitleStreamKey'],
  postSubtitleRefreshStreamKey: () => ['postSubtitleRefreshStreamKey'],
});
